import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import React from 'react';

import { useFieldAttributes } from '../../contexts/field-attributes-context';
import { useFieldPropsV2 } from '../../contexts/field-props-context';
import { getErrorDataHook } from '../../services/field-attributes';

export type ErrorProps = {
  className?: string;
};

export const Error = ({ className }: ErrorProps) => {
  const { target, hasError, errorMessage } = useFieldPropsV2();
  const { errorId } = useFieldAttributes();

  if (!hasError) {
    return null;
  }

  return (
    <div
      id={errorId}
      data-hook={getErrorDataHook(target)}
      className={className}
    >
      <ErrorSmall aria-hidden />
      {errorMessage ?? ''}
    </div>
  );
};
